import {Grid} from "@mui/material";
import {Link} from "react-router-dom";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import CheckIcon from "@mui/icons-material/Check";
import React from "react";

export function RouteViewSelector(props: {
    value: "calendar" | "list" | "ops";
}) {
    return (
        <>
            <Grid item>
                <Link to="/logistics/routes/">
                    <SmallGreyButton startIcon={props.value === "calendar" ? <CheckIcon /> : undefined}>
                        Calendar View
                    </SmallGreyButton>
                </Link>
            </Grid>
            <Grid item>
                <Link to="/logistics/routes/list">
                    <SmallGreyButton startIcon={props.value === "list" ? <CheckIcon /> : undefined}>
                        List View
                    </SmallGreyButton>
                </Link>
            </Grid>
            <Grid item>
                <Link to="/logistics/routes/ops">
                    <SmallGreyButton startIcon={props.value === "ops" ? <CheckIcon /> : undefined}>
                        Ops Board
                    </SmallGreyButton>
                </Link>
            </Grid>
        </>
    )
}